import { render, staticRenderFns } from "./SynergismSubtabButton.vue?vue&type=template&id=b30deff4&scoped=true&"
import script from "./SynergismSubtabButton.vue?vue&type=script&lang=js&"
export * from "./SynergismSubtabButton.vue?vue&type=script&lang=js&"
import style0 from "./SynergismSubtabButton.vue?vue&type=style&index=0&id=b30deff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30deff4",
  null
  
)

export default component.exports